module.exports = __webpack_public_path__ + "static/media/google-play.43593a4f.png";